import { useEffect, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { PROMPT_TAG_SEARCH } from '../../../../const';

import { useStyles } from './useStyles';

export const PromptTagNode = ({ element, children, attributes }) => {
  const styles = useStyles();

  const childTextLower = element?.children?.[0]?.text?.toLowerCase();
  const [assetBackground, setAssetBackground] = useState(false);

  useEffect(() => {
    if (
      childTextLower?.includes(PROMPT_TAG_SEARCH.productDetails) ||
      childTextLower?.includes(PROMPT_TAG_SEARCH.productDescription)
    ) {
      setAssetBackground(true);
    }
  }, [childTextLower]);

  return (
    <span
      className={cx(styles.root, {
        [styles.assetBackground]: assetBackground,
      })}
      {...attributes}
    >
      {children}
    </span>
  );
};

PromptTagNode.propTypes = {
  attributes: PropTypes.shape().isRequired,
  element: PropTypes.shape().isRequired,
  children: PropTypes.node,
};
PromptTagNode.defaultProps = {
  children: null,
};
